import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    IGetConnectorTypeSuccessAction,
    IGetConnectorTypeAction,
    IGetConnectorTypeErrorAction
} from '../actions/connector-types/connector-types';
import { IStoreIntState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadConnectorTypesAction
    = IGetConnectorTypeAction
    | IGetConnectorTypeSuccessAction
    | IGetConnectorTypeErrorAction

const init = (state: IStoreIntState, action: LoadConnectorTypesAction) => ({
    ...state,
    connectorTypeOptions: {
        ...state.connectorTypeOptions,
        status: action.status
    }
});

const success = (state: IStoreIntState, action: LoadConnectorTypesAction) => ({
    ...state,
    connectorTypeOptions: {
        status: action.status,
        data: (action as IGetConnectorTypeSuccessAction).data
    }
});

const failure = (state: IStoreIntState, action: LoadConnectorTypesAction) => ({
    ...state,
    connectorTypeOptions: {
        ...initialState.connectorTypeOptions,
        status: action.status,
        error: (action as IGetConnectorTypeErrorAction).error
    }
});

export const loadConnectorTypesReducer = createAsyncReducer(initialState, init, success, failure);